import * as Yup from 'yup';

export const adminUserSchema = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .min(2, 'minimum2CharactersError')
    .required('requiredFirstName'),
  lastName: Yup.string()
    .trim()
    .min(2, 'minimum2CharactersError')
    .required('requiredLastName'),
  email: Yup.string()
    .trim()
    .email('invalidEmailError')
    .max(255)
    .required('requiredEmail'),
  phone: Yup.string()
    .trim(),
  mobilephone: Yup.string()
    .trim(),
  workphone: Yup.string()
    .trim(),  
  objectId: Yup.number()
    .typeError('apartmentNumberMustBeNumeric')
    .required('requiredApartmentNumber'),
  address: Yup.string().trim().required('requiredAddress'),
  addressId: Yup.string().trim().required('requiredAddressId'),
  postalCode: Yup.string().trim().required('requiredPostalCode'),
});
